import { SharedColumnSettingsService } from './../../../modules/shared/services/column-settings.service';
import { ColumnSettingsN } from './../../../modules/shared/models/column-settings.model';
import { PhoneNumberFormatService } from './../../../modules/shared/services/phone-number-format.service';
import { AccountsHttpService } from '../../../modules/shared/services/accounts.http.service';
import { PermissionService } from '../../../service/permission.service';
import { ObjectNames } from '../../../shared/constants';
import { ContactService } from '../../../contacts/contactService';
import { CONTACT_ASSOCIATION_ID } from '../../../modules/shared/constants/typeId';
import { ParseHelper } from '../../../modules/shared/parse.helper';
import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core';
import {
  AbstractControl,
  FormArray,
  FormBuilder,
  FormGroup,
  Validators,
} from '@angular/forms';
import { catchError, map, takeUntil, tap } from 'rxjs/operators';
import { of, Subject } from 'rxjs';

// Components
import { AppMainComponent } from 'src/app/app.main.component';

// Models
import { Account } from '../../models/account.model';
import { AccountContact } from 'src/app/accounts/model/accountContact';
import { Contact } from 'src/app/accounts/model/contact';
import { ContactSpokenLanguage } from 'src/app/shared/model/contactSpokenLanguage';
import { TemplateSection } from 'src/app/modules/shared/model/templateSection.model';

// Constants and Enums
import { Status } from '../../accounts.enum';
import { AccountModuleId } from 'src/app/modules/shared/constants/modules.constant';
import { Sections } from '../../accounts.constant';
import {
  CUSTOMFIELD_TYPE_IDS,
  EMAIL_TYPE_IDS,
  PHONE_TYPE_IDS,
  SOCIAL_PROFILE_TYPE_IDS,
} from 'src/app/modules/shared/constants/typeId';

// Services
import { AppMainService } from 'src/app/app-main.service';
import { AccountService } from 'src/app/accounts/accountService';
import {
  ConfirmationService,
  ConfirmEventType,
  MessageService,
} from 'primeng/api';
import { FileService } from 'src/app/modules/shared/services/file.service';

// Helpers
import { AccountHelper } from '../../services/accounts.helper';
import { SharedDataService } from 'src/app/modules/shared/stores/sharedDataStore/sharedData.service';
import { AccountLeadDataService } from 'src/app/modules/shared/stores/accountLeadDataStore/accountLeadData.service';
import { uploadFiles, validateFiles } from 'src/app/shared/upload-files';
import { SharedCRMConfigService } from 'src/app/configurations/crm/shared/services/shared-crm-config.service';
import { CustomAttributeService } from 'src/app/modules/shared/services/custom-attribute.service';
import { AccountServiceN } from '../../services/account.services';
import { generateContactName } from 'src/app/modules/shared/helpers/generate-contact-name.helper';
import { Tag } from '../../models/tag.model';
import { AccountUserService } from 'src/app/service/account.service';
import { ImportserialService } from 'src/app/modules/shared/services/importserial.service';
import { CompanyBranchService } from 'src/app/configurations/company-branch/company-branch.service';
import { ConfigurationService } from 'src/app/configurations/configurationService';

type AccountControls = { [key in keyof Account]: AbstractControl };
type AccountFormGroup = FormGroup & {
  value: Account;
  controls: AccountControls;
};

@Component({
  selector: 'app-edit-account',
  templateUrl: './edit-account.component.html',
  styleUrls: ['./edit-account.component.scss'],
})
export class EditAccountComponent implements OnInit, OnChanges, OnDestroy{
  @Input() displayEditViewDialog: boolean = false;
  @Input() displayView: boolean = false;
  @Input() selectedChannelId: number = 0;
  @Input() selectedAccountId: number = 0;
  @Input() selectedView: string = 'list';

  @Output() getAccountDetailsAfterEdit: EventEmitter<any> =
    new EventEmitter<any>();
  @Output() getAccountListAfterEdit: EventEmitter<any> =
    new EventEmitter<any>();
  @Output() closeModal: EventEmitter<any> = new EventEmitter<any>();
  @Output() switchToView = new EventEmitter();

  /* Permission */
  readPermission: boolean;
  writePermission: boolean;
  editPermission: boolean;
  deletePermission: boolean;
  exportPermission: boolean;
  readContactPermission: boolean;

  selectedAccount: any;
  viewAccountData: any = null;
  showAccountInfoMore: boolean = false;
  userAccessByTerritoryList: any[] = [];
  objectId: number = AccountModuleId;
  accountForm: AccountFormGroup;
  accountExistMsg: string = '';
  selectedParentAccount: any = null;
  parentSearch = [];
  storedContactDetails: any[] = [];
  storedAccountEmails: any[] = [];
  storedAccountPhones: any[] = [];
  storedAccountSocials: any[] = [];
  selectedcontactProfileImages = [];
  accountTempAddress = [];
  accountModuleId = AccountModuleId;
  templateSections: TemplateSection[] = [];
  noTemplateMessage: string = '';
  checkedFields: any = {};
  selectedCategory;
  tabIndex: number = 0;
  contactListAttn = [];
  countryData: any;
  tempSelection:any=null;
  isRemoveble:boolean=false;

  detailsLoadingFailed: boolean = false;
  detailsErrorMessage: string = '';

  // Emails, Phones, Socials IDs
  emailIds = EMAIL_TYPE_IDS;
  phoneIds = PHONE_TYPE_IDS;
  socialIds = SOCIAL_PROFILE_TYPE_IDS;
  customFieldIds = CUSTOMFIELD_TYPE_IDS;

  // Contact Emails
  contactEmails = [];
  workEmail: any = {
    email: {},
  };
  homeEmail: any = {
    email: {},
  };
  ce1: any = {
    email: {},
  };
  ce2: any = {
    email: {},
  };

  // Contact Phones
  contactPhones = [];
  workPhone: any = {
    phone: {},
  };
  homePhone: any = {
    phone: {},
  };
  mobilePhone: any = {
    phone: {},
  };
  cp1: any = {
    phone: {},
  };
  cp2: any = {
    phone: {},
  };

  // Contact Socials
  contactSocials = [];
  contactFacebook: any = {
    socialProfile: {},
  };
  contactTwitter: any = {
    socialProfile: {},
  };
  contactLinkedin: any = {
    socialProfile: {},
  };
  contactInstagram: any = {
    socialProfile: {},
  };
  contactWebsite: any = {
    socialProfile: {},
  };

  // Account Emails
  accountEmails = [];

  // Account Phones
  accountPhones = [];

  // Account Socials
  accountSocials = [];
  accountFacebook: any = {
    socialProfile: {},
  };
  accountTwitter: any = {
    socialProfile: {},
  };
  accountLinkedin: any = {
    socialProfile: {},
  };
  accountInstagram: any = {
    socialProfile: {},
  };
  accountWebsite: any = {
    socialProfile: {},
  };

  // Attachments
  allowedExtensions = ['.png', '.jpg', '.jpeg', '.gif']; // For the attachment files
  contactAttachments = {
    id: 0,
    createdSource: this.app.userIP,
    updatedSource: this.app.userIP,
    createdBy: this.app.user.userId,
    updatedBy: this.app.user.userId,
    createdDate: new Date(),
    updatedDate: new Date(),
    contactId: 0,
    attachmentId: 0,
    attachment: {
      id: 0,
      createdSource: 'string',
      updatedSource: 'string',
      createdBy: this.app.user.userId,
      updatedBy: 0,
      createdDate: new Date(),
      updatedDate: new Date(),
      name: 'string',
      guidName: 'string',
      location: 'string',
      content: 'string',
      extension: 'string',
      sizeInBytes: 0,
      description: 'string',
      statusId: 0,
      isValid: true,
      validFromDate: '2021-04-03T14:18:49.091Z',
      validToDate: '2021-04-03T14:18:49.091Z',
    },
  };

  // Custom Attributes
  accountInfoCustomFields = [];
  accountInfoCustomValues = [];
  accountDetailsCustomFields = [];
  accountDetailsCustomValues = [];

  activeUsers = [];
  stages = [];
  salutations = [];
  jobFunctions = [];
  contactRoles: any[] = [];
  accountTypes = [];
  accountSources = [];
  employeeCount = [];
  timezones = [];
  currencies = [];
  ratings = [];
  revenues = [];
  ownerships = [];
  industries = [];
  countries = [];
  languages = [];
  addressTypes = [];
  addressClasses = [];
  isSubmitted = false;
  //tags
  tags: Tag[] = [];
  isEditTag = false;
  displayAddTag = false;
  tempTag = { id: 0, name: '', color: '#000000' };
  tagList: Tag[] = [];
  selectedValues: any[] = [];
  pageSize: number = 5;
  selectedTag: Tag;
  filteredTagList: Tag[] = [];
  filterDropdownList: { name: string; id: number }[] = [
    { name: 'Assigned', id: 1 },
    { name: 'UnAssigned', id: 2 },
    { name: 'All', id: 3 },
  ];
  first: number = 0;
  displayCreateTag: boolean = false;
  // Subject to unsubscribe
  private ngUnsubscribe = new Subject<void>();

  /** Custom Section */
  customSections: TemplateSection[] = [];
  customSectionsForView: TemplateSection[] = [];
  customSectionFields = [];
  customSectionValues = [];
  stageCommentEnable:boolean = false;
  accountOwnerSettings: any = {};
  selectedOwnerStageDefault: any = {};
  selectedOwnerStage: any = {};
  phoneNumberFormat: string = null;
  isChildTemplate:boolean=false

    //Parent Account Selection
    displayManualPopup: boolean = false;
    manualRuleColumnSetttings: Partial<ColumnSettingsN> = {};
    selectedRecordList: any[] = [];
    selectedChannel: any = null;
    selectedModule = {id: AccountModuleId, name: 'Account'};

  constructor(
    private app: AppMainComponent,
    private fb: FormBuilder,
    private accountService: AccountService,
    private accountServiceN: AccountServiceN,
    private messageService: MessageService,
    public appMainService: AppMainService,
    private sharedConfigService: SharedCRMConfigService,
    private accountHelper: AccountHelper,
    private accountDataService: AccountLeadDataService,
    private accountsHttpService: AccountsHttpService,
    private customAttributeService: CustomAttributeService,
    private sharedDataService: SharedDataService,
    private fileService: FileService,
    private contactService: ContactService,
    private confirmationService: ConfirmationService,
    private permissionService: PermissionService,
    private accountUserService: AccountUserService,
    private phoneNumberFormatService: PhoneNumberFormatService,
    private columnSettingsService: SharedColumnSettingsService,
    private importService: ImportserialService,private companyBranchService: CompanyBranchService,
    private configurationService: ConfigurationService,
  ) {}

  ngOnInit() {
    this.getDropdownValues();
    this.getCountryCode();
    this.getPhoneNumberTemplate();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (
      changes.displayEditViewDialog &&
      changes.displayEditViewDialog.currentValue
    ) {
      this.displayEditViewDialog = changes.displayEditViewDialog.currentValue;
      this.tabIndex = 0;
    }

    if (changes?.displayView && changes?.displayView?.currentValue) {
      this.displayView = changes?.displayView?.currentValue;
    }

    if (
      changes?.selectedChannelId &&
      changes?.selectedChannelId?.currentValue
    ) {
      this.selectedChannelId = changes?.selectedChannelId?.currentValue;
    }

    if (
      changes?.selectedAccountId &&
      changes?.selectedAccountId?.currentValue &&
      this.displayEditViewDialog
    ) {
      this.selectedAccountId = changes?.selectedAccountId?.currentValue;
      this.accountEditView();
    }
  }

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  accountEditView() {
    this.getAccountDetailsById(this.selectedAccountId);
  }

  // Get Account Details from API
  getAccountDetailsById(id) {
    this.appMainService.isShowSpinner('getAccountDetailsById');
    this.detailsLoadingFailed = false;
    this.detailsErrorMessage = '';
    this.accountsHttpService
      .getAccountDetails(id,true)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(
        (resp) => {
          this.selectedAccount = resp;

          if(!this.selectedChannelId){ this.selectedChannelId = resp?.typeId;}
          // -------------------------tags code
          if (this.selectedAccount?.tags?.length > 0) {
            this.tags = this.selectedAccount?.tags;
          }
          this.loadTags();
          this.getAllStages();
          this.setDefaultStage();
          this.setSelectedAccountDetails(resp);
        //   this.storeService.setAccountData(this.selectedAccount);
          this.selectedAccount.accountContacts =
            this.sortContactAccordingToPrimary(
              this.selectedAccount.accountContacts
            );
          this.contactListAttn = this.selectedAccount.accountContacts?.filter(
            (el) => el.contact
          );

          if (this.selectedAccount.accountContacts) {
            this.generateContactEmails();
            this.generateContactPhones();
            this.generateContactSocials();
          }

          if (this.selectedChannelId) {
            this.getTemplateFormFields(this.selectedChannelId);
            // if(this.selectedAccount.mainCustomerId){
            //   this.getTemplateFormFields(this.selectedChannelId,true);
            // }
            // else{
            //   this.getTemplateFormFields(this.selectedChannelId,false);
            // }
            this.setPermissions();
          }
          this.appMainService.isHideSpinner('getAccountDetailsById');
        },
        (error) => {
          this.appMainService.isHideSpinner('getAccountDetailsById');
          this.detailsLoadingFailed = true;
          switch (error?.status) {
            case 404:
              this.detailsErrorMessage = "You're not permitted to view this account details!";
              break;
            default:
              this.detailsErrorMessage = 'Error occurring when fetching accounts details. Please try after sometimes.';
              this.messageService.add({
                severity: 'error',
                summary: 'Error!',
                detail: this.detailsErrorMessage,
              });
              break;
          }
        }
      );
  }
  isCurrencyChangeAllowed() {
    this.companyBranchService.validateCurrencyPermissions(this.selectedAccount?.id,true).subscribe(resp => {
      if (resp) {
        this.accountForm.get('currencyUnit')?.disable();
      }
    });
  }
  // Set Details of the Selected Account
  setSelectedAccountDetails(account: any): void {
    if (!account) {
      return;
    }

    let contactName: string = '';
    if (
      account.accountContacts?.length &&
      account.accountContacts[0] &&
      account.accountContacts[0].contact
    ) {
      const contactDetails = account.accountContacts[0].contact;
      contactName = generateContactName(contactDetails);
    }

    const data = {
      ...account,
      contactName: contactName,
      accountStatus: account.accountStatus?.name || '',
      accountTypesNames: account.accountTypes?.length
        ? this.accountHelper.processAccountNames(account.accountTypes)
        : null,
      statusName: account.status ? account.status.name : null,
    };

    let responseData: any = this.accountHelper.processAccountDetailsData(data);
    this.selectedAccount = responseData;
  }

  // Set permissions for read, write, edit, delete and export
  setPermissions(): void {
    const userPermissions = this.permissionService.getPermissionData();

    if (userPermissions.length) {
      let accountPermission = userPermissions.find(
        (obj) => obj.objectName === ObjectNames.ACCOUNT
      );
      let contactPermission = userPermissions.find(
        (obj) => obj.objectName === ObjectNames.CONTACT
      );

      accountPermission = accountPermission.permissions.sort((a, b) =>
        a.permissionId < b.permissionId ? -1 : 1
      );
      contactPermission = contactPermission.permissions.sort((a, b) =>
        a.permissionId < b.permissionId ? -1 : 1
      );

      this.readPermission =
        accountPermission &&
        accountPermission[0].permissionId == 1 &&
        accountPermission[0].statusId == 1;
      this.writePermission =
        accountPermission &&
        accountPermission[1].permissionId == 2 &&
        accountPermission[1].statusId == 1;
      this.editPermission =
        accountPermission &&
        accountPermission[2].permissionId == 3 &&
        accountPermission[2].statusId == 1;
      this.deletePermission =
        accountPermission &&
        accountPermission[3].permissionId == 4 &&
        accountPermission[3].statusId == 1;
      this.exportPermission =
        accountPermission &&
        accountPermission[4].permissionId == 5 &&
        accountPermission[4].statusId == 1;
      this.readContactPermission =
        contactPermission &&
        contactPermission[0].permissionId == 1 &&
        contactPermission[0].statusId == 1;
    }
  }

  sortContactAccordingToPrimary(accountContacts) {
    let sortedContacts =
      accountContacts?.length > 0
        ? accountContacts.sort(
            (a, b) => b.isPrimaryContact - a.isPrimaryContact
          )
        : [];
    return sortedContacts || [];
  }

  prepareAccountForm(data?:any) {
    this.accountForm = this.fb.group({
      id: [data?.id || 0],
      typeId: [data?.typeId || 0],
      description: [data?.description || ''],
      businessName: [data?.businessName || '', [Validators.maxLength(100)]],
      sequenceNumber: [{value: data?.sequenceNumber || '', disabled: true}],
      accountNumber: [data?.accountNumber || '', [Validators.maxLength(50)]],
      accountSource: [data?.accountSource],
      currencyId: [data?.currencyUnit?.id || null],
      timeZoneId: [data?.timeZone?.id || null],
      taxId: [data?.taxId || null, [Validators.maxLength(50)]],
      ownershipId: [data?.ownershipId || null],
      accountName: [data?.accountName || data?.businessName],
      accountTypes: [null],
      ownerId: [],
      selectedAccountTypes: [],
      organizationId: [data?.organizationId || this.app.user.organizationId],
      leadId: [data?.leadId || null],
      doingBusinessAs: [
        data?.doingBusinessAs || '',
        [Validators.maxLength(50)],
      ],
      branchId: [data?.branchId || ''],
      accountsourceId: [data?.accountSource?.id || null],
      sourceId: [data?.source?.id || null],
      paymentTerm: [data?.paymentTerm || ''],
      paymentMethod: [data?.paymentMethod || ''],
      storePicture: [data?.storePicture || ''],
      industryId: [data?.industry?.id || null],
      mainCustomerId: [data?.parent?.id || null],
      annualRevenueId: [data?.annualRevenue?.id || null],
      ratingId: [data?.rating?.id || null],
      employeesRangeId: [data?.employeesRange?.id || null],
      tickerSymbol: [ data?.tickerSymbol || ''],
      accountCategory: [data?.businessClassification?.name || ''],
      gstNo: [data?.gstNo || ''],
      panNo: [data?.panNo || ''],
      accountStatusId: [data?.accountStatusId || null],
      totalBalance: [data?.totalBalance || 0],
      accountCategoryColor: [data?.accountCategoryColor || ''],
      statusId: [data?.statusId || 1],
      isValid: [data?.isValid || true],
      validFrom: [data?.validFrom || null],
      validTo: [data?.validTo || null],
      websiteURL: [data?.websiteURL || ''],
      webTechnologies: [data?.webTechnologies || ''],
      facebookPage: [data?.facebookPage || ''],
      linkedinPage: [data?.linkedinPage || ''],
      twitterPage: [data?.twitterPage || ''],
      instagramPage: [data?.instagramPage || ''],
      sicCode: [data?.sicCode || null],
      naicsCode: [data?.naicsCode || null],
      foundedYearId: [data?.foundedYearId || null],
      businessClassification: [data?.businessClassification?.id || null],
      accountContacts: this.fb.array([this.getNewContact(data)]),
      createdSource: [data?.createdSource || this.app.userIP],
      createdBy: [data?.createdBy || this.app.user.userId],
      number: [data?.number || 0],
      parentAccountId: [null],
      parent: [null],
      source: [null],
      rating: [null],
      timeZone: [null],
      currencyUnit: data?.currencyUnit || [null],
      ownerShipType: [data?.ownership || 0],
      annualRevenue: [''],
      employeesRange: [''],
      industry: [''],
      foundedYear: [data?.foundedYear || null, Validators.maxLength(15)],
      accountTargetLists: [''],
      customAttributeValues: this.fb.array(this.newCustomAttributes([])),
      createdDate: [data?.createdDate || null],
      updatedBy: [this.app.user.userId],
      updatedDate: [new Date()],
      updatedSource: [this.app.user.userIP],
      stageOwnerId: [data?.stageOwnerId || null],
      comment: [data?.comment || null]
    }) as any;
  }

  generateContactEmails() {
    const model = {
      accountId: this.selectedAccount.id,
      contactId: this.selectedAccount.accountContacts[0]?.contact?.id,
      emailId: 0,
      id: 0,
      tempValue: '',
      updatedBy: null,
      updatedDate: null,
      updatedSource: null,
      email: {
        emailType: null,
        name: '',
        description: '',
        emailTypeId: 0,
        id: 0,
        status: null,
        statusId: 1,
        updatedBy: null,
        updatedDate: null,
        updatedSource: null,
      },
    };

    const contactEmails =
      this.selectedAccount.accountContacts[0]?.contact?.contactEmails;

    // Work Email
    const foundWorkEmail = contactEmails?.find(
      (el) => el.email.emailTypeId === this.emailIds.WORK
    );

    if (foundWorkEmail) {
      this.workEmail = foundWorkEmail;
      this.workEmail['tempValue'] = ParseHelper.DeepCopy(
        this.workEmail.email.emailAddress
      );
    } else {
      this.workEmail = JSON.parse(JSON.stringify(model));
      this.workEmail.email.emailTypeId = this.emailIds.WORK;
    }

    // Home Email
    const foundHomeEmail = contactEmails?.find(
      (el) => el.email.emailTypeId === this.emailIds.HOME
    );

    if (foundHomeEmail) {
      this.homeEmail = foundHomeEmail;
      this.homeEmail['tempValue'] = ParseHelper.DeepCopy(
        this.homeEmail.email.emailAddress
      );
    } else {
      this.homeEmail = JSON.parse(JSON.stringify(model));
      this.homeEmail.email.emailTypeId = this.emailIds.HOME;
    }

    // CE1
    const foundCE1 = contactEmails?.find(
      (el) => el.email.emailTypeId === this.emailIds.CE1
    );

    if (foundCE1) {
      this.ce1 = foundCE1;
      this.ce1['tempValue'] = ParseHelper.DeepCopy(this.ce1.email.emailAddress);
    } else {
      this.ce1 = JSON.parse(JSON.stringify(model));
      this.ce1.email.emailTypeId = this.emailIds.CE1;
    }

    // CE2
    const foundCE2 = contactEmails?.find(
      (el) => el.email.emailTypeId === this.emailIds.CE2
    );

    if (foundCE2) {
      this.ce2 = foundCE2;
      this.ce2['tempValue'] = ParseHelper.DeepCopy(this.ce2.email.emailAddress);
    } else {
      this.ce2 = JSON.parse(JSON.stringify(model));
      this.ce2.email.emailTypeId = this.emailIds.CE2;
    }
  }

  generateContactPhones() {
    const defaultCountry = this.app.userDetails?.locations?.[0]?.address?.country?.name || this.app.organizationData?.address?.country?.name;
    const defaultCode = this.app.userDetails?.locations?.[0]?.address?.country?.phoneCode || this.app.organizationData?.address?.country?.phoneCode;

    const model = {
      accountId: this.selectedAccount.id,
      contactId: this.selectedAccount.accountContacts[0]?.contact?.id,
      phoneId: 0,
      id: 0,
      tempValue: '',
      updatedBy: null,
      updatedDate: null,
      updatedSource: null,
      phone: {
        phoneType: null,
        country: defaultCountry,
        code: defaultCode,
        number: '',
        description: '',
        phoneTypeId: 0,
        id: 0,
        status: null,
        statusId: 1,
        updatedBy: null,
        updatedDate: null,
        updatedSource: null,
      },
    };

    const contactPhones =
      this.selectedAccount.accountContacts[0]?.contact?.contactPhones;

    // Work Phone
    const foundWorkPhone = contactPhones?.find(
      (el) => el.phone.phoneTypeId === this.phoneIds.WORK
    );

    if (foundWorkPhone) {
      this.workPhone = foundWorkPhone;
      this.workPhone.phone.maskingDisabled = this.phoneNumberFormatService.checkMaskingDisabled(this.workPhone.phone.number);
      this.workPhone['tempValue'] = ParseHelper.DeepCopy(
        this.workPhone.phone.number
      );
    } else {
      this.workPhone = JSON.parse(JSON.stringify(model));
      this.workPhone.phone.phoneTypeId = this.phoneIds.WORK;
    }

    // Home Phone
    const foundHomePhone = contactPhones?.find(
      (el) => el.phone.phoneTypeId === this.phoneIds.HOME
    );

    if (foundHomePhone) {
      this.homePhone = foundHomePhone;
      this.homePhone.phone.maskingDisabled = this.phoneNumberFormatService.checkMaskingDisabled(this.homePhone.phone.number);
      this.homePhone['tempValue'] = ParseHelper.DeepCopy(
        this.homePhone.phone.number
      );
    } else {
      this.homePhone = JSON.parse(JSON.stringify(model));
      this.homePhone.phone.phoneTypeId = this.phoneIds.HOME;
    }

    // Mobile Phone
    const foundMobilePhone = contactPhones?.find(
      (el) => el.phone.phoneTypeId === this.phoneIds.MOBILE
    );

    if (foundMobilePhone) {
      this.mobilePhone = foundMobilePhone;
      this.mobilePhone.phone.maskingDisabled = this.phoneNumberFormatService.checkMaskingDisabled(this.mobilePhone.phone.number);
      this.mobilePhone['tempValue'] = ParseHelper.DeepCopy(
        this.mobilePhone.phone.number
      );
    } else {
      this.mobilePhone = JSON.parse(JSON.stringify(model));
      this.mobilePhone.phone.phoneTypeId = this.phoneIds.MOBILE;
    }

    // CP1
    const foundCP1 = contactPhones?.find(
      (el) => el.phone.phoneTypeId === this.phoneIds.CP1
    );

    if (foundCP1) {
      this.cp1 = foundCP1;
      this.cp1.phone.maskingDisabled = this.phoneNumberFormatService.checkMaskingDisabled(this.cp1.phone.number);
      this.cp1['tempValue'] = ParseHelper.DeepCopy(
        this.cp1.phone.number
      );
    } else {
      this.cp1 = JSON.parse(JSON.stringify(model));
      this.cp1.phone.phoneTypeId = this.phoneIds.CP1;
    }

    // CP2
    const foundCP2 = contactPhones?.find(
      (el) => el.phone.phoneTypeId === this.phoneIds.CP2
    );

    if (foundCP2) {
      this.cp2 = foundCP2;
      this.cp2.phone.maskingDisabled = this.phoneNumberFormatService.checkMaskingDisabled(this.cp2.phone.number);
      this.cp2['tempValue'] = ParseHelper.DeepCopy(
        this.cp2.phone.number
      );
    } else {
      this.cp2 = JSON.parse(JSON.stringify(model));
      this.cp2.phone.phoneTypeId = this.phoneIds.CP2;
    }
  }

  generateContactSocials() {
    const model = {
      accountId: this.selectedAccount.id,
      contactId: this.selectedAccount.accountContacts[0]?.contact?.id,
      socialProfileId: 0,
      id: 0,
      tempValue: '',
      updatedBy: null,
      updatedDate: null,
      updatedSource: null,
      socialProfile: {
        socialProfileType: null,
        name: '',
        description: '',
        socialProfileTypeId: 0,
        id: 0,
        status: null,
        statusId: 1,
        updatedBy: null,
        updatedDate: null,
        updatedSource: null,
      },
    };

    const contactSocials =
      this.selectedAccount.accountContacts[0]?.contact?.contactSocialProfiles;

    // Facebook
    const foundFacebook = contactSocials?.find(
      (el) => el.socialProfile.socialProfileTypeId === this.socialIds.FACEBOOK
    );

    if (foundFacebook) {
      this.contactFacebook = foundFacebook;
      this.contactFacebook['tempValue'] = ParseHelper.DeepCopy(
        this.contactFacebook.socialProfile.name
      );
    } else {
      this.contactFacebook = JSON.parse(JSON.stringify(model));
      this.contactFacebook.socialProfile.socialProfileTypeId =
        this.socialIds.FACEBOOK;
    }

    // Twitter
    const foundTwitter = contactSocials?.find(
      (el) => el.socialProfile.socialProfileTypeId === this.socialIds.TWITTER
    );

    if (foundTwitter) {
      this.contactTwitter = foundTwitter;
      this.contactTwitter['tempValue'] = ParseHelper.DeepCopy(
        this.contactTwitter.socialProfile.name
      );
    } else {
      this.contactTwitter = JSON.parse(JSON.stringify(model));
      this.contactTwitter.socialProfile.socialProfileTypeId =
        this.socialIds.TWITTER;
    }

    // Linked In
    const foundLinkedIn = contactSocials?.find(
      (el) => el.socialProfile.socialProfileTypeId === this.socialIds.LINKEDIN
    );

    if (foundLinkedIn) {
      this.contactLinkedin = foundLinkedIn;
      this.contactLinkedin['tempValue'] = ParseHelper.DeepCopy(
        this.contactLinkedin.socialProfile.name
      );
    } else {
      this.contactLinkedin = JSON.parse(JSON.stringify(model));
      this.contactLinkedin.socialProfile.socialProfileTypeId =
        this.socialIds.LINKEDIN;
    }

    // Instagram
    const foundInstagram = contactSocials?.find(
      (el) => el.socialProfile.socialProfileTypeId === this.socialIds.INSTAGRAM
    );

    if (foundInstagram) {
      this.contactInstagram = foundInstagram;
      this.contactInstagram['tempValue'] = ParseHelper.DeepCopy(
        this.contactInstagram.socialProfile.name
      );
    } else {
      this.contactInstagram = JSON.parse(JSON.stringify(model));
      this.contactInstagram.socialProfile.socialProfileTypeId =
        this.socialIds.INSTAGRAM;
    }

    // Website
    const foundWebsite = contactSocials?.find(
      (el) => el.socialProfile.socialProfileTypeId === this.socialIds.WEBSITE
    );

    if (foundWebsite) {
      this.contactWebsite = foundWebsite;
      this.contactWebsite['tempValue'] = ParseHelper.DeepCopy(
        this.contactWebsite.socialProfile.name
      );
    } else {
      this.contactWebsite = model;
      this.contactWebsite.socialProfile.socialProfileTypeId =
        this.socialIds.WEBSITE;
    }
  }

  generateAccountEmails() {
    this.selectedAccount.accountEmails =
      this.selectedAccount?.accountEmails?.filter((el) => el.email);

    if (this.selectedAccount.accountEmails?.length) {
      this.accountEmails = [this.selectedAccount.accountEmails[0]];
    } else {
      this.accountEmails = [
        {
          accountId: this.selectedAccount.id,
          emailId: 0,
          emailTypeId: 30,
          id: 0,
          updatedBy: null,
          updatedDate: null,
          updatedSource: null,
          email: {
            description: '',
            emailAddress: '',
            emailType: null,
            emailTypeId: 30,
            id: 0,
            status: null,
            statusId: 1,
            updatedBy: null,
            updatedDate: null,
            updatedSource: null,
          },
        },
      ];
    }
  }

  generateAccountPhones() {

    const defaultCountry = this.app.userDetails?.locations?.[0]?.address?.country?.name||this.app.organizationData?.address?.country?.name;
    const defaultCode = this.app.userDetails?.locations?.[0]?.address?.country?.phoneCode||this.app.organizationData?.address?.country?.phoneCode;

    this.selectedAccount.accountPhones =
      this.selectedAccount?.accountPhones?.filter((el) => el.phone);

    if (this.selectedAccount.accountPhones?.length) {
      this.accountPhones = [this.selectedAccount.accountPhones[0]];
      this.accountPhones[0].phone['maskingDisabled']= this.phoneNumberFormatService.checkMaskingDisabled(this.accountPhones[0].phone.number);
    } else {
      this.accountPhones = [
        {
          accountId: this.selectedAccount.id,
          phoneId: 0,
          id: 0,
          updatedBy: null,
          updatedDate: null,
          updatedSource: null,
          phoneTypeId: 12,
          phone: {
            country: defaultCountry,
            code: defaultCode,
            number: '',
            extension: '',
            phoneTypeId: 12,
            id: 0,
            status: null,
            statusId: 1,
            updatedBy: null,
            updatedDate: null,
            updatedSource: null,
          },
        },
      ];
    }
  }

  generateAccountSocials() {
    const model = {
      accountId: this.selectedAccount.id,
      socialProfileId: 0,
      id: 0,
      updatedBy: null,
      updatedDate: null,
      updatedSource: null,
      socialProfile: {
        socialProfileType: null,
        name: '',
        description: '',
        socialProfileTypeId: 0,
        id: 0,
        status: null,
        statusId: 1,
        updatedBy: null,
        updatedDate: null,
        updatedSource: null,
      },
    };

    const accountSocials = this.selectedAccount.accountSocials;

    // Facebook
    const foundFacebook = accountSocials?.find(
      (el) => el.socialProfile?.socialProfileTypeId === this.socialIds?.FACEBOOK
    );

    if (foundFacebook) {
      this.accountFacebook = foundFacebook;
    } else {
      this.accountFacebook = JSON.parse(JSON.stringify(model));
      this.accountFacebook.socialProfile.socialProfileTypeId =
        this.socialIds.FACEBOOK;
    }

    // Twitter
    const foundTwitter = accountSocials?.find(
      (el) => el.socialProfile?.socialProfileTypeId === this.socialIds?.TWITTER
    );

    if (foundTwitter) {
      this.accountTwitter = foundTwitter;
    } else {
      this.accountTwitter = JSON.parse(JSON.stringify(model));
      this.accountTwitter.socialProfile.socialProfileTypeId =
        this.socialIds.TWITTER;
    }

    // Linked In
    const foundLinkedIn = accountSocials?.find(
      (el) => el.socialProfile?.socialProfileTypeId === this.socialIds?.LINKEDIN
    );

    if (foundLinkedIn) {
      this.accountLinkedin = foundLinkedIn;
    } else {
      this.accountLinkedin = JSON.parse(JSON.stringify(model));
      this.accountLinkedin.socialProfile.socialProfileTypeId =
        this.socialIds.LINKEDIN;
    }

    // Instagram
    const foundInstagram = accountSocials?.find(
      (el) =>
        el.socialProfile?.socialProfileTypeId === this.socialIds?.INSTAGRAM
    );

    if (foundInstagram) {
      this.accountInstagram = foundInstagram;
    } else {
      this.accountInstagram = JSON.parse(JSON.stringify(model));
      this.accountInstagram.socialProfile.socialProfileTypeId =
        this.socialIds.INSTAGRAM;
    }

    // Website
    const foundWebsite = accountSocials?.find(
      (el) => el.socialProfile?.socialProfileTypeId === this.socialIds?.WEBSITE
    );

    if (foundWebsite) {
      this.accountWebsite = foundWebsite;
    } else {
      this.accountWebsite = model;
      this.accountWebsite.socialProfile.socialProfileTypeId =
        this.socialIds.WEBSITE;
    }
  }

  createFormField(control?) {
    return {
      id: 0,
      updatedSource: 'string',
      updatedBy: 0,
      updatedDate: new Date(),
      objectId: 2,
      objectValue: 0,
      customAttributeId: control?.id,
      customAttribute: control,
      value:
        control?.isRequired &&
        (control?.formControl.name == 'InputBox' ||
          control?.formControl.name == 'RadioButton' ||
          control?.formControl.name == 'DatePicker')
          ? ['', Validators.required]
          : '',
      values:
        control?.isRequired && control?.formControl.name == 'DropDownList'
          ? [null, Validators.required]
          : null,
      multipleValues:
        control?.isRequired &&
        control?.formControl.name == 'MultipleDropDownList'
          ? [null, Validators.required]
          : null,
      multipleCheckBox:
        control?.isRequired && control?.formControl.name == 'CheckBox'
          ? [null, Validators.required]
          : null,
      customeAttachement:
        control?.isRequired && control?.formControl.name == 'FileUpload'
          ? [null, Validators.required]
          : null,
      ratingId:
        control?.isRequired && control?.formControl.name == 'Rating'
          ? [0, Validators.required]
          : 0,
      toggle:
        control?.isRequired && control?.formControl.name == 'ToggleButton'
          ? [false, Validators.required]
          : false,
      statusId: 1,
    };
  }

  generateAcccountInfoCustomFields() {
    const customAttributeValues =
      this.selectedAccount?.customAttributeValues || [];
    const sectionCustomFields = this.templateSections[1]?.customFields || [];
    const data = this.customAttributeService.generateCustomFieldValues(
      'Account',
      'Information',
      customAttributeValues,
      sectionCustomFields
    );
    this.accountInfoCustomFields = data.customFields;
    this.accountInfoCustomValues = data.customValues;
  }

  generateAcccountDetailsCustomFields() {
    const customAttributeValues =
      this.selectedAccount?.customAttributeValues || [];
    const sectionCustomFields = this.templateSections[2]?.customFields || [];
    const data = this.customAttributeService.generateCustomFieldValues(
      'Account',
      'Details',
      customAttributeValues,
      sectionCustomFields
    );
    this.accountDetailsCustomFields = data.customFields;
    this.accountDetailsCustomValues = data.customValues;
  }

  /** Custom Section */

  prepareCustomSectionFields() {
    const customAttributeValues = this.selectedAccount?.customAttributeValues || [];
    this.customSections = this.templateSections.filter(section => section.systemGenerated == false);
    this.customSections = this.customSections.filter(section=> section && section.customFields && section.customFields.length > 0);

    for(let section of this.customSections){
      const sectionCustomFields = section?.customFields || [];
      if(sectionCustomFields.length > 0){
        const data = this.customAttributeService.generateCustomFieldValues('Account', 'Custom Section', customAttributeValues, sectionCustomFields);
        if(data.customFields && data.customFields.length > 0 && data.customValues && data.customValues.length > 0){
          this.customSectionsForView.push(section);
        }
        this.customSectionFields.push(data.customFields);
        this.customSectionValues.push(data.customValues);
      } else {
        this.customSectionFields.push(null);
        this.customSectionValues.push(null);
      }
    }
  }

  /** End Custom Section */

  getTemplateFormFields(channelId: number,isChildTemplate?:boolean): void {
    this.appMainService.isShowSpinner('getTemplateFormFields');
    this.sharedConfigService
      .getTemplateFormFields(this.accountModuleId, channelId,isChildTemplate)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe({
        next: (response) => {
          this.templateSections = response || [];
          this.markCheckedFields();
          this.loadUsers();
          this.showEditViewAccount();
          this.prepareAccountViewUI();
          this.noTemplateMessage = '';
        },
        error: () => {
          this.templateSections = [];
          this.noTemplateMessage = 'Error loading template under this channel.';
        },
        complete: () => {
          this.appMainService.isHideSpinner('getTemplateFormFields');
        },
      });
  }

  markCheckedFields(): void {
    // this.checkedFields={};
    for (const section of this.templateSections) {
      for (const fieldData of section.fields) {
        if (fieldData.name) {
          if (fieldData.childFields?.length) {
            fieldData.name = this.accountHelper.processFieldName(
              fieldData.name
            );

            this.checkedFields[fieldData.name] = {
              labelName: fieldData.labelName,
            };

            for (const childFieldData of fieldData.childFields) {
              childFieldData.name = this.accountHelper.processFieldName(
                childFieldData.name
              );

              if (
                section.name === Sections.CONTACT_DETAILS &&
                fieldData.name === 'SocialProfile'
              ) {
                childFieldData.name = 'Contact' + childFieldData.name;
              } else if (
                section.name === Sections.ACCOUNT_DETAILS &&
                fieldData.name === 'AccountSocial'
              ) {
                childFieldData.name = 'Account' + childFieldData.name;
              }

              this.checkedFields[childFieldData.name] = {
                labelName: childFieldData.labelName,
              };
            }
          } else {
            fieldData.name = this.accountHelper.processFieldName(
              fieldData.name
            );

            if (
              fieldData.name == 'AccountEmail' ||
              fieldData.name == 'AccountPhone'
            ) {
              continue;
            }

            this.checkedFields[fieldData.name] = {
              labelName: fieldData.labelName,
            };
          }
        }
      }
    }
  }

  uploadProfilePic(files: File[]) {
    this.appMainService.isShowSpinner('upload');
    if (typeof Worker !== undefined) {
      for (let file of files) {
        let errors = validateFiles(file, 2, this.allowedExtensions);
        if (errors.length > 0) {
          for (let error of errors) {
            this.messageService.add({
              severity: 'error',
              summary: 'Error',
              detail: error.fileName + ': ' + error.error,
            });
          }
          this.appMainService.isHideSpinner('upload');
        } else {
          uploadFiles(file, ({ name, content, size, extension }) => {
            let attachment = {
              id: 0,
              createdSource: this.app.userIP,
              updatedSource: this.app.userIP,
              createdBy: this.app.user.userId,
              updatedBy: 0,
              createdDate: new Date(),
              updatedDate: new Date(),
              name: name,
              guidName: 'string',
              location: 'string',
              content: content,
              extension: extension,
              sizeInBytes: size,
              description: 'string',
              statusId: Status.Active,
              isValid: true,
              validFromDate: null,
              validToDate: null,
            };

            this.contactAttachments = {
              id: 0,
              createdSource: this.app.userIP,
              updatedSource: this.app.userIP,
              createdBy: this.app.user.userId,
              updatedBy: this.app.user.userId,
              createdDate: new Date(),
              updatedDate: new Date(),
              contactId: 0,
              attachmentId: 0,
              attachment: attachment,
            };
            this.selectedcontactProfileImages.push(this.contactAttachments);
            this.appMainService.isHideSpinner('upload');
          });
        }
      }
    } else {
      this.messageService.add({
        severity: 'error',
        summary: 'Error',
        detail:
          'Please update the browser. Web Workers are not supported in the older versions of this browser.',
      });
    }
  }

  removeProfileImg(ind) {
    this.selectedcontactProfileImages[ind].attachment.statusId = Status.Deleted;
  }

  searchParent(event) {
    let data = {
      currentPage: 0,
      pageSize: 0,
      organizationId: this.app.user.organizationId,
      loginUserId: this.app.user.userId,
      search: event.query,
      channelId: this.selectedChannelId,
    };
    this.accountService.getAllAccounts(data).then((accounts) => {
      const activeAccounts = accounts?.filter(
        (obj) =>
          obj.statusId == 1 &&
          this.selectedAccount?.businessName !== obj.businessName &&
          obj.businessName.length
      );
      this.parentSearch = activeAccounts || [];

      if (!this.parentSearch.length) {
        this.parentSearch.push({ name: 'No Accounts found.' });
      }
    });
  }

    openParentAcountDialog() {
        this.chooseAccountCol();
        this.selectedChannel = { id: this.selectedChannelId };
        this.selectedRecordList = this.selectedParentAccount ? ParseHelper.DeepCopy([this.selectedParentAccount]) : [];
        this.displayManualPopup = true;
    }

    removeParentAccount() {
        // this.getTemplateFormFields(this.selectedChannelId, false);
        // this.isRemoveble=true
        this.selectedParentAccount = null;
        // this.tempSelection=null
    }

    saveParentAccount($event) {
        this.selectedRecordList = ParseHelper.DeepCopy($event.selectedReccords);
        if (this.selectedRecordList?.length > 0) {
            const selectedParentAccount = ParseHelper.DeepCopy(this.selectedRecordList[0]);

            if(this.accountForm.value.id!==selectedParentAccount.id){
              // this.isRemoveble=true
                this.selectedParentAccount = selectedParentAccount;
                // this.tempSelection=selectedParentAccount
                // this.getTemplateFormFields(this.selectedChannelId, true);
            }else{
                this.messageService.add({
                    severity: 'error',
                    summary: 'Error',
                    detail: 'Parent Account can\'t be the same account',
                });
            }
        }       

        this.displayManualPopup = false;
    }

    chooseAccountCol() {
        this.columnSettingsService.getColumnSettings(this.selectedModule.id, this.selectedChannelId).subscribe(
            resp => {
                let defaultColumnSettings: Partial<ColumnSettingsN> = ParseHelper.DeepCopy(resp);
                this.manualRuleColumnSetttings = defaultColumnSettings;
            },
            err => {
            }
        );
    }

    columnSettingSaved($event) {
        this.manualRuleColumnSetttings = $event;
    }

    manualpopupCancelClicked() {
        this.displayManualPopup = false;
    }

  prepareAccountViewUI(): void {
    this.viewAccountData = ParseHelper.DeepCopy(this.accountHelper.processViewData(this.selectedAccount));
    this.app.objectId = this.selectedAccount?.id;
    this.app.objectType = ObjectNames.ACCOUNT;
  }

  async showEditViewAccount() {
    this.generateAccountPhones();
    this.generateAccountSocials();
    this.generateAccountEmails();
    this.generateAcccountInfoCustomFields();
    this.generateAcccountDetailsCustomFields();
    this.prepareCustomSectionFields();
    this.isCurrencyChangeAllowed();

    this.accountForm = null;
    this.storedContactDetails = JSON.parse(
      JSON.stringify(this.selectedAccount.accountContacts || [])
    );
    this.storedAccountEmails = JSON.parse(
      JSON.stringify(this.selectedAccount.accountEmails || [])
    );
    this.storedAccountPhones = JSON.parse(
      JSON.stringify(this.selectedAccount.accountPhones || [])
    );
    this.storedAccountSocials = JSON.parse(
      JSON.stringify(this.selectedAccount.accountSocials || [])
    );

    this.prepareAccountForm(this.selectedAccount);

    this.formControl.firstName.setValidators([
      Validators.required,
      Validators.pattern('^[^:]*$'),
    ]);

    if (
      this.selectedAccount &&
      this.selectedAccount.accountContacts &&
      this.selectedAccount.accountContacts.length > 0 &&
      this.selectedAccount.accountContacts[0].contact &&
      this.selectedAccount.accountContacts[0].contact.contactProfileImages
    ) {
      this.selectedcontactProfileImages =
        this.selectedAccount.accountContacts[0].contact.contactProfileImages.filter(
          (x) => x.attachment != null
        ) || [];
    }
    this.selectedcontactProfileImages.forEach((element) => {
      if (element?.attachment?.content) {
        const kept = element.attachment.content.split(',', 2);
        const elem = kept[1];
        element.attachment.content = `data:image/png;base64,` + elem;
      }
    });

    const temp: Account = JSON.parse(JSON.stringify(this.selectedAccount));
    temp.customAttributeValues = [];
    const { accountContacts = [], accountTypes } = temp;

    let selectedContactSpokenLanguages = [];
    const contactSpokenLanguages =
      accountContacts[0]?.contact?.contactSpokenLanguages;

    if (contactSpokenLanguages) {
      selectedContactSpokenLanguages =
        contactSpokenLanguages && contactSpokenLanguages.length
          ? this.getSelectedValues(
              contactSpokenLanguages,
              this.languages,
              'language'
            )
          : [];
      accountContacts[0].contact['selectedContactSpokenLanguages'] =
        selectedContactSpokenLanguages;
    }
    if (accountContacts[0]?.contact) {
      accountContacts[0].contact.dateOfBirth = new Date(
        accountContacts[0]?.contact?.dateOfBirth
      );
      accountContacts[0].contact.startDate = new Date(
        accountContacts[0]?.contact?.startDate
      );

      if (
        accountContacts[0]?.contact?.contactRoles &&
        accountContacts[0]?.contact?.contactRoles.length > 0
      ) {
        const contactRolesId  = this.getContactRolesId(this.selectedAccount.accountContacts[0]?.contact?.contactRoles);
        accountContacts[0].contact.contactRoles = contactRolesId;
      }
    }



    const owner = this.activeUsers.find(
      (user) => user.id === this.selectedAccount?.ownerId
    );
    const selectedAccountTypes =
      accountTypes && Array.isArray(accountTypes)
        ? this.getSelectedValues(accountTypes, this.accountTypes, 'type')
        : [];

    this.selectedParentAccount = null;

    if (this.selectedAccount.mainCustomer ) {
      // && !this.isRemoveble
        this.selectedParentAccount = {
            id: this.selectedAccount.mainCustomerId,
            businessName: this.selectedAccount.mainCustomer,
            sequenceNumber: this.selectedAccount?.parentAccountSequenceNumber
        }
    }
    // if(this.isRemoveble){
    //   if(this.tempSelection)
    //    this.selectedParentAccount = {...this.tempSelection}
    //   else{
    //     this.selectedParentAccount=null
    //   }
    // }
    this.accountForm?.patchValue({
      ...temp,
      ownerId: owner,
      typeId: this.selectedChannelId,
      selectedAccountTypes,
      parent: this.selectedParentAccount,
    });

    if (this.stages?.length > 0) {
      this.setBusinessClassification();
    }

    this.accountForm.get('businessName').updateValueAndValidity();
    this.accountTempAddress = this.selectedAccount.accountAddresses;
  }

  setBusinessClassification() {
    const tempBusinessClassification = this.stages.find(
      (data) => data.id === this.selectedAccount['businessClassificationId']
    );
    const defaultStage = this.stages.find(
      (data) =>
        data.name.toLowerCase() === 'prospects' ||
        data.name.toLowerCase() === 'prospect' ||
        data.name.toLowerCase() === 'propspect' ||
        data.id == 1
    );
    this.selectedAccount['businessClassification'] = tempBusinessClassification ? tempBusinessClassification : defaultStage;
    this.accountForm.patchValue({
        businessClassification: this.selectedAccount['businessClassification'],
    });
  }

  onUpdateAddressList($event) {
    this.accountTempAddress = $event.addressList;
    this.accountTempAddress.sort(this.compare);
  }

  compare(a, b) {
    if (a.address.name < b.address.name) {
      return -1;
    }

    if (a.address.name > b.address.name) {
      return 1;
    }

    return 0;
  }

  createEmptyFormField(control) {
    return {
      id: 0,
      createdSource: 'string',
      updatedSource: 'string',
      createdBy: 0,
      updatedBy: 0,
      createdDate: new Date(),
      updatedDate: new Date(),
      objectId: this.objectId,
      objectValue: 0,
      customAttributeId: control.id,
      customAttribute: control,
      value:
        control.formControl.name == 'InputBox' ||
        control.formControl.name == 'RadioButton' ||
        control.formControl.name == 'DatePicker'
          ? ''
          : '',
      values: control.formControl.name == 'DropDownList' ? null : null,
      multipleValues:
        control.formControl.name == 'MultipleDropDownList' ? null : null,
      multipleCheckBox: control.formControl.name == 'CheckBox' ? null : null,
      customeAttachement:
        control.formControl.name == 'FileUpload' ? null : null,
      ratingId: control.formControl.name == 'Rating' ? 0 : 0,
      toggle: control.formControl.name == 'ToggleButton' ? false : false,
      statusId: 1,
    };
  }

  getSelectedValues(data = [], options, key) {
    return data.reduce((previousType, current) => {
      const index = this.accountTypes.findIndex(
        (_details) => _details.id === current[key].id
      );
      if (index !== -1) {
        previousType.push(options[index]);
      }
      return previousType;
    }, []);
  }

  get formControl(): any {
    const account: FormArray = this.accountForm?.controls
      .accountContacts as FormArray;
    const address: FormArray = this.accountForm?.controls
      .accountAddresses as FormArray;
    return {
      contactEmailsArray: (<FormArray>(
        account?.controls[0]?.get('contact').get('contactEmails')
      )) as FormArray,
      contactPhonesArray: (<FormArray>(
        account?.controls[0]?.get('contact').get('contactPhones')
      )) as FormArray,

      contact: <FormGroup>account?.controls[0]?.get('contact'),
      firstName: <FormGroup>(
        account?.controls[0]?.get('contact').get('firstName')
      ),
      lastName: <FormGroup>account?.controls[0]?.get('contact').get('lastName'),
      accountContacts: (<FormArray>account) as FormArray,
      accountAddresses: (<FormArray>address) as FormArray,
      firstAddress: <FormGroup>address?.controls[0]?.get('address'),
      bus: <FormGroup>account?.controls[0]?.get('contact').get('lastName'),
      accountContactControls: (<AbstractControl>(
        account?.controls[0]
      )) as AbstractControl,
      businessClassification: <FormGroup>(
        this.accountForm?.get('businessClassification')
      ),
      contactSocialProfilesArray: (<FormArray>(
        account?.controls[0]?.get('contact').get('contactSocialProfiles')
      )) as FormArray,
    };
  }

  scrollToError(): void {
    const firstElementWithError = document.querySelector(
      '.ng-invalid[formControlName]'
    );
    this.scrollTo(firstElementWithError);

    if (!firstElementWithError) {
      const secondElementWithError = document.querySelector('.p-invalid');
      this.scrollTo(secondElementWithError);
    }
  }

  scrollTo(el: Element): void {
    if (el) {
      el.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  }

  getUpdateProperties() {
    return {
      updatedBy: this.app.user.organizationId,
      updatedDate: new Date(),
      updatedSource: this.app.userIP,
    };
  }

  removePropertyFromObject(data, propArray) {
    const details = Object.keys(data).reduce((object, key) => {
      const index = propArray.findIndex((_data) => _data === key);
      if (index == -1) {
        object[key] = data[key];
      }
      return object;
    }, {});

    return details;
  }

  getAccountEmails({
    accountEmails = [],
    id: accountId,
  }): Array<AccountContact> {
    const _accountId = accountId || 0;
    const propToRemove = [
      'socialProfileType',
      'emailType',
      'status',
      'phoneType',
    ];
    const updateDetails = this.getUpdateProperties();

    if (
      this.storedAccountEmails &&
      this.storedAccountEmails.length > 0 &&
      accountEmails.length > 0
    ) {
      for (const stored of this.storedAccountEmails) {
        let emailTypeId = 0;
        emailTypeId =
          stored['email']?.emailType == null
            ? 0
            : stored['email']?.emailType?.id;
        const getActualEmail = accountEmails.find(
          (el) => el['email'].emailType.id == emailTypeId
        );
        const getActualEmailIndex = accountEmails.findIndex(
          (el) => el['email'].emailType.id == emailTypeId
        );
        if (getActualEmail && getActualEmail['email'].emailAddress == '') {
          getActualEmail['email'].emailAddress = stored['email']?.emailAddress;
          getActualEmail['email'].statusId = 3;
        }
        accountEmails[getActualEmailIndex] = getActualEmail;
      }
    }

    // If empty value then remove
    accountEmails = accountEmails.filter((data) => {
      return data.email?.emailType?.id !== 0 && data.email?.emailAddress !== '';
    });

    // Remove email Type
    accountEmails = accountEmails.map((data) => {
      data.emailTypeId = data.email?.emailType?.id;
      data.accountId = data.accountId || _accountId;
      data.email = this.removePropertyFromObject(data.email, propToRemove);
      data.updatedSource = updateDetails.updatedSource;
      return data;
    });

    accountEmails = accountEmails.length === 0 ? null : accountEmails;
    return accountEmails;
  }

  getAccountSocials({
    accountSocials = [],
    id: accountId,
  }): Array<AccountContact> {
    const _accountId = accountId || 0;
    const propToRemove = [
      'socialProfileType',
      'emailType',
      'status',
      'phoneType',
    ];
    const updateDetails = this.getUpdateProperties();

    if (
      this.storedAccountSocials &&
      this.storedAccountSocials.length > 0 &&
      accountSocials.length > 0
    ) {
      for (const stored of this.storedAccountSocials) {
        let socialProfileTypeId =
          stored['socialProfile'].socialProfileType == null
            ? 0
            : stored['socialProfile']?.socialProfileType?.id;
        const getActualSocial = accountSocials.find(
          (el) =>
            el['socialProfile'].socialProfileType.id == socialProfileTypeId
        );
        const getActualSocialIndex = accountSocials.findIndex(
          (el) =>
            el['socialProfile'].socialProfileType.id == socialProfileTypeId
        );
        if (getActualSocial && getActualSocial['socialProfile'].name == '') {
          getActualSocial['socialProfile'].name = stored['socialProfile'].name;
          getActualSocial['socialProfile'].statusId = 3;
        }
        accountSocials[getActualSocialIndex] = getActualSocial;
      }
    }

    // if empty value then remove
    accountSocials = accountSocials.filter((data) => {
      return (
        data.socialProfile?.socialProfileType?.id !== 0 &&
        data.socialProfile?.name !== ''
      );
    });
    // remove socialProfileType property
    accountSocials = accountSocials.map((data) => {
      data.accountId = data.accountId || _accountId;
      data.socialProfileId = data.socialProfile.id;
      data.socialProfile = this.removePropertyFromObject(
        data.socialProfile,
        propToRemove
      );
      data.updatedSource = updateDetails.updatedSource;
      return data;
    });

    accountSocials = accountSocials.length === 0 ? null : accountSocials;
    return accountSocials;
  }

  getAccountTypes(selectedAccountTypes, accountTypes = [], accountId = 0) {
    accountTypes = accountTypes || [];
    if (!selectedAccountTypes) {
      return null;
    }
    return selectedAccountTypes.map((type) => {
      const index = accountTypes.findIndex((data) => data.type.id === type.id);
      if (index !== -1) {
        return {
          ...accountTypes[index],
        };
      }
      return {
        id: 0,
        typeId: type.id,
        statusId: type?.statusId || 1,
        accountId: accountId,
        createdSource: type?.createdSource || this.app.userIP,
        createdBy: type?.createdBy || this.app.user.userId,
        createdDate: type?.createdDate || new Date(),
      };
    });
  }

  prepareContactSpokenLanguage(
    selectedContactSpokenLanguages,
    contactSpokenLanguages = [],
    contactId = 0
  ): Array<ContactSpokenLanguage> {
    contactSpokenLanguages = contactSpokenLanguages || [];
    return selectedContactSpokenLanguages.map((language) => {
      const index = contactSpokenLanguages.findIndex(
        (data) => data.language.id === language.id
      );
      if (index !== -1) {
        return {
          ...contactSpokenLanguages[index],
        };
      }
      return {
        id: 0,
        ContactId: contactId,
        statusId: language?.statusId || 1,
        LanguageId: language?.id || 0,
        Language: null,
        createdSource: language?.createdSource || this.app.userIP,
        createdBy: language?.createdBy || this.app.user.userId,
        createdDate: language?.createdDate || new Date(),
      };
    });
  }

  prepareContactRoles(selectedContactRoles, contactId) {
    const contactRoles = [];
    if (selectedContactRoles && selectedContactRoles.length) {
      selectedContactRoles.map((role) => {
        const temp = {
          contactId: contactId,
          roleId: role.id,
          id: 0,
          createdSource: this.app.user.userIP,
          updatedSource: null,
          createdBy: this.app.user.userId,
          updatedBy: null,
          createdDate: new Date(),
          updatedDate: null,
          statusId: Status.Active,
        };
        contactRoles.push(temp);
      });
    }
    return contactRoles.length ? contactRoles : null;
  }

  getAccountContactMapData(data: Contact) {
    let _data: Contact = {
      ...data,
      firstName: data?.firstName?.trim(),
      middleName: data?.middleName?.trim(),
      lastName: data?.lastName?.trim(),
      salutationId: data?.salutation?.id || null,
      sourceId: data?.source?.id || null,
      contactAssociationTypeId: CONTACT_ASSOCIATION_ID.ACCOUNT,
      genderId: data?.gender?.id || null,
      degreeId: data?.degree?.id || null,
      fieldOfStudyId: data?.fieldOfStudy?.id || null,
      contactTypeId: data?.contactType?.id || null,
      relationshipStatusId: data?.relationshipStatus?.id || null,
      maritalStatusId: data?.maritalStatus?.id || null,
      annualIncomeId: data?.annualIncome?.id || null,
      assistantId: data?.assistant?.id || null,
      organizationId: data?.organizationId || this.app.user.organizationId,
      contactRoleId: data?.contactRoleId||null,
      contactSpokenLanguages:
        data?.contactSpokenLanguages?.length > 0
          ? this.prepareContactSpokenLanguage(
              data['selectedContactSpokenLanguages'],
              data?.contactSpokenLanguages,
              data?.id
            )
          : [],
      customAttributeValues:
        data.customAttributeValues && data.customAttributeValues.length > 0
          ? data.customAttributeValues
          : null,
    };
    const propToRemove = [
      'maritalStatus',
      'gender',
      'source',
      'annualIncome',
      'degree',
      'contactType',
      'relationshipStatus',
      'status',
      'fieldOfStudy',
      'assistant',
      'contactAssociationType',
    ];
    _data = this.removePropertyFromObject(_data, propToRemove);
    return _data;
  }

  getAccountContacts({
    accountContacts = [],
    id: accountId,
  }): Array<AccountContact> {
    const _accountId = accountId || 0;
    const updateDetails = this.getUpdateProperties();
    accountContacts = accountContacts.map((data: AccountContact) => {
      return {
        ...data,
        accountId: data.contact?.associationId||_accountId,
        contact: this.getAccountContactMapData(data.contact),
      };
    });

    accountContacts[0].contact.updatedSource = updateDetails.updatedSource;

    // Contact Emails Payload
    this.contactEmails = [];

    if (
      this.workEmail?.email?.emailAddress?.length &&
      this.workEmail?.tempValue?.length == 0 &&
      this.workEmail.id > 0
    ) {
      this.workEmail.email.statusId = 3;
      this.contactEmails.push(this.workEmail);
    } else if (this.workEmail?.tempValue?.length) {
      this.workEmail.email.emailAddress = ParseHelper.DeepCopy(
        this.workEmail.tempValue
      );
      this.contactEmails.push(this.workEmail);
    }

    if (
      this.homeEmail?.email?.emailAddress?.length &&
      this.homeEmail?.tempValue?.length == 0 &&
      this.homeEmail.id > 0
    ) {
      this.homeEmail.email.statusId = 3;
      this.contactEmails.push(this.homeEmail);
    } else if (this.homeEmail?.tempValue?.length) {
      this.homeEmail.email.emailAddress = ParseHelper.DeepCopy(
        this.homeEmail.tempValue
      );
      this.contactEmails.push(this.homeEmail);
    }

    if (
      this.ce1?.email?.emailAddress?.length &&
      this.ce1?.tempValue?.length == 0 &&
      this.ce1.id > 0
    ) {
      this.ce1.email.statusId = 3;
      this.contactEmails.push(this.ce1);
    } else if (this.ce1?.tempValue?.length) {
      this.ce1.email.emailAddress = ParseHelper.DeepCopy(this.ce1.tempValue);
      this.contactEmails.push(this.ce1);
    }

    if (
      this.ce2?.email?.emailAddress?.length &&
      this.ce2?.tempValue?.length == 0 &&
      this.ce2.id > 0
    ) {
      this.contactEmails.push(this.ce2);
      this.ce2.email.statusId = 3;
    } else if (this.ce2?.tempValue?.length) {
      this.ce2.email.emailAddress = ParseHelper.DeepCopy(this.ce2.tempValue);
      this.contactEmails.push(this.ce2);
    }

    // Contact Phones Payload
    this.contactPhones = [];

    if (
      this.workPhone?.phone?.number?.length &&
      this.workPhone?.tempValue?.trim().length == 0 &&
      this.workPhone.id > 0
    ) {
      this.workPhone.phone.statusId = 3;
      this.contactPhones.push(this.workPhone);
    } else if (this.workPhone?.tempValue.trim().length) {
      this.workPhone.phone.number = ParseHelper.DeepCopy(
        `${this.workPhone.phone.code||''}${this.phoneNumberFormatService.removeMaskingFromNumber(this.workPhone.tempValue)}`
      );
      this.contactPhones.push(this.workPhone);
    }

    if (
      this.homePhone?.phone?.number?.length &&
      this.homePhone?.tempValue?.trim().length == 0 &&
      this.homePhone.id > 0
    ) {
      this.homePhone.phone.statusId = 3;
      this.contactPhones.push(this.homePhone);
    } else if (this.homePhone?.tempValue.trim().length) {
      this.homePhone.phone.number = ParseHelper.DeepCopy(
        `${this.homePhone.phone.code||''}${this.phoneNumberFormatService.removeMaskingFromNumber(this.homePhone.tempValue)}`);
      this.contactPhones.push(this.homePhone);
    }

    if (
      this.mobilePhone?.phone?.number?.length &&
      this.mobilePhone?.tempValue?.trim().length == 0 &&
      this.mobilePhone.id > 0
    ) {
      this.mobilePhone.phone.statusId = 3;
      this.contactPhones.push(this.mobilePhone);
    } else if (this.mobilePhone?.tempValue.trim().length) {
      this.mobilePhone.phone.number = ParseHelper.DeepCopy(
        `${this.mobilePhone.phone.code||''}${this.phoneNumberFormatService.removeMaskingFromNumber(this.mobilePhone.tempValue)}`
      );
      this.contactPhones.push(this.mobilePhone);
    }

    if (
      this.cp1?.phone?.number?.length &&
      this.cp1?.tempValue?.trim().length == 0 &&
      this.cp1.id > 0
    ) {
      this.cp1.phone.statusId = 3;
      this.contactPhones.push(this.cp1);
    } else if (this.cp1?.tempValue?.trim().length) {
      this.cp1.phone.number = ParseHelper.DeepCopy(
        `${this.cp1.phone.code||''}${this.phoneNumberFormatService.removeMaskingFromNumber(this.cp1.tempValue)}`
      );
      this.contactPhones.push(this.cp1);
    }

    if (
      this.cp2?.phone?.number?.length &&
      this.cp2?.tempValue?.trim().length == 0 &&
      this.cp2.id > 0
    ) {
      this.contactPhones.push(this.cp2);
      this.cp2.phone.statusId = 3;
    } else if (this.cp2?.tempValue?.trim().length) {
      this.cp2.phone.number = ParseHelper.DeepCopy(
        `${this.cp2.phone.code||''}${this.phoneNumberFormatService.removeMaskingFromNumber(this.cp2.tempValue)}`
      );
      this.contactPhones.push(this.cp2);
    }

    // Contact Socials Payload
    this.contactSocials = [];

    if (
      this.contactFacebook?.socialProfile?.name?.length &&
      this.contactFacebook?.tempValue?.length == 0 &&
      this.contactFacebook.id > 0
    ) {
      this.contactFacebook.socialProfile.statusId = 3;
      this.contactSocials.push(this.contactFacebook);
    } else if (this.contactFacebook?.tempValue?.length) {
      this.contactFacebook.socialProfile.name = ParseHelper.DeepCopy(
        this.contactFacebook.tempValue
      );
      this.contactSocials.push(this.contactFacebook);
    }

    if (
      this.contactTwitter?.socialProfile?.name?.length &&
      this.contactTwitter?.tempValue?.length == 0 &&
      this.contactTwitter.id > 0
    ) {
      this.contactTwitter.socialProfile.statusId = 3;
      this.contactSocials.push(this.contactTwitter);
    } else if (this.contactTwitter?.tempValue?.length) {
      this.contactTwitter.socialProfile.name = ParseHelper.DeepCopy(
        this.contactTwitter.tempValue
      );
      this.contactSocials.push(this.contactTwitter);
    }

    if (
      this.contactLinkedin?.socialProfile?.name?.length &&
      this.contactLinkedin?.tempValue?.length == 0 &&
      this.contactLinkedin.id > 0
    ) {
      this.contactLinkedin.socialProfile.statusId = 3;
      this.contactSocials.push(this.contactLinkedin);
    } else if (this.contactLinkedin?.tempValue?.length) {
      this.contactLinkedin.socialProfile.name = ParseHelper.DeepCopy(
        this.contactLinkedin.tempValue
      );
      this.contactSocials.push(this.contactLinkedin);
    }

    if (
      this.contactInstagram?.socialProfile?.name?.length &&
      this.contactInstagram?.tempValue?.length == 0 &&
      this.contactInstagram.id > 0
    ) {
      this.contactInstagram.socialProfile.statusId = 3;
      this.contactSocials.push(this.contactInstagram);
    } else if (this.contactInstagram?.tempValue?.length) {
      this.contactInstagram.socialProfile.name = ParseHelper.DeepCopy(
        this.contactInstagram.tempValue
      );
      this.contactSocials.push(this.contactInstagram);
    }

    if (
      this.contactWebsite?.socialProfile?.name?.length &&
      this.contactWebsite?.tempValue?.length == 0 &&
      this.contactWebsite.id > 0
    ) {
      this.contactWebsite.socialProfile.statusId = 3;
      this.contactSocials.push(this.contactWebsite);
    } else if (this.contactWebsite?.tempValue?.length) {
      this.contactWebsite.socialProfile.name = ParseHelper.DeepCopy(
        this.contactWebsite.tempValue
      );
      this.contactSocials.push(this.contactWebsite);
    }

    if (accountContacts[0].contact.salutation) {
      accountContacts[0].contact.salutation.organizationId =
        this.app.user.organizationId;
    }

    accountContacts[0].contact.contactEmails = this.contactEmails;
    accountContacts[0].contact.contactPhones = this.contactPhones;
    accountContacts[0].contact.contactSocialProfiles = this.contactSocials;

    if (
      !accountContacts[0].contact?.contactSocialProfiles?.length &&
      !accountContacts[0].contact.contactPhones?.length &&
      !accountContacts[0].contact.contactEmails?.length &&
      !accountContacts[0].contact.title &&
      !accountContacts[0].contact.firstName &&
      !accountContacts[0].contact.lastName
    ) {
      return null;
    }

    return accountContacts;
  }

  getPreparedData(data): any {
    if (!data.businessName?.length) {
      const firstName = data.accountContacts[0].contact.firstName;
      const lastName = data.accountContacts[0].contact.lastName;
      data.businessName = `${firstName} ${lastName}`;
    }

    // Account Emails
    if (!this.accountEmails[0]?.email?.emailAddress?.length) {
      this.accountEmails = [];
    }

    // Account Phones
    let accountPhone = [];
    if (this.accountPhones[0]?.phone?.number?.trim()?.length) {
        accountPhone = ParseHelper.DeepCopy(this.accountPhones);
        accountPhone[0].phone.number = `${accountPhone[0]?.phone?.code||''}${this.phoneNumberFormatService.removeMaskingFromNumber(accountPhone[0]?.phone?.number)}`
    }

    // Account Socials
    this.accountSocials = [];

    if (this.accountFacebook?.socialProfile?.name?.length) {
      this.accountSocials.push(this.accountFacebook);
    }

    if (this.accountTwitter?.socialProfile?.name?.length) {
      this.accountSocials.push(this.accountTwitter);
    }

    if (this.accountLinkedin?.socialProfile?.name?.length) {
      this.accountSocials.push(this.accountLinkedin);
    }

    if (this.accountInstagram?.socialProfile?.name?.length) {
      this.accountSocials.push(this.accountInstagram);
    }

    if (this.accountWebsite?.socialProfile?.name?.length) {
      this.accountSocials.push(this.accountWebsite);
    }

    let customAttributeValues = this.getCustomAttributePayload();

    let response = {
      id: data?.id || 0,
      typeId: data.typeId || 0,
      description: data?.description || '',
      accountPhones: accountPhone,
      accountEmails: this.accountEmails,
      accountSocials: this.accountSocials,
      businessName: data?.businessName.trim() || '',
      sequenceNumber: data?.sequenceNumber || '',
      accountNumber: data.accountNumber || '',
      accountSource: data.accountSource,
      currencyId: data?.currencyUnit?.id || data?.currencyId || null,
      timeZoneId: data?.timeZone?.id || data?.timeZoneId || null,
      taxId: data?.taxId || null,
      ownerId: data?.ownerId?.id,
      ownershipId: data?.ownershipId || null,
      accountName: data?.accountName || data?.businessName,
      accountTypes:
        this.getAccountTypes(
          data.selectedAccountTypes,
          data.accountTypes,
          data.accountId
        ) || null,
      organizationId: data?.organizationId || this.app.user.organizationId,
      leadId: data?.leadId || null,
      doingBusinessAs: data?.doingBusinessAs || '',
      branchId: data?.branchId || '',
      accountsourceId: data?.accountSource?.id || null,
      sourceId: data?.source?.id || null,
      paymentTerm: data?.paymentTerm || '',
      paymentMethod: data?.paymentMethod || '',
      storePicture: data?.storePicture || '',
      industryId: data?.industry?.id || null,
      mainCustomerId: data?.parent?.id || null,
      annualRevenueId: data?.annualRevenue?.id || null,
      ratingId: data?.rating?.id || null,
      employeesRangeId: data?.employeesRange?.id || null,
      tickerSymbol: data?.tickerSymbol || '',
      businessClassificationId: data?.businessClassification?.id || null,
      businessClassification: data?.businessClassification || null,
      accountCategory: data?.businessClassification?.name || '',
      gstNo: data?.gstNo || '',
      panNo: data?.panNo || '',
      accountStatusId: data?.accountStatusId || null,
      totalBalance: data?.totalBalance || 0,
      accountCategoryColor: data?.accountCategoryColor || '',
      statusId: data?.statusId || 1,
      isValid: data?.isValid || true,
      validFrom: data?.validFrom || null,
      validTo: data?.validTo || null,
      websiteURL: data?.websiteURL || '',
      webTechnologies: data?.webTechnologies || '',
      facebookPage: data?.facebookPage || '',
      linkedinPage: data?.linkedinPage || '',
      twitterPage: data?.twitterPage || '',
      instagramPage: data?.instagramPage || '',
      sicCode: data?.sicCode || null,
      naicsCode: data?.naicsCode || null,
      foundedYear: data?.foundedYear || null,
      foundedYearId: data?.foundedYear?.id || null,
      accountContacts: this.getAccountContacts(data),
      customAttributeValues,
      createdSource: data?.createdSource || this.app.userIP,
      createdBy: data?.createdBy || this.app.user.userId,
      number: data?.number || 0,
      createdDate: data?.createdDate || new Date(),
      updatedBy: this.app.user.userId,
      updatedDate: new Date(),
      updatedSource: this.app.user.userIP,
      comment: data?.comment || null,
      // tags: this.tags,
      availableCredit: this.selectedAccount?.availableCredit || 0,
      creditLimit:  this.selectedAccount?.creditLimit || 0,
      dailyMax:  this.selectedAccount?.dailyMax || 0,
      monthlyMax:  this.selectedAccount?.monthlyMax || 0,
      usedLimit:  this.selectedAccount?.usedLimit || 0,
      weeklyMax:  this.selectedAccount?.weeklyMax || 0,
      accountCreditControlId: this.selectedAccount?.accountCreditControlId || 0,
      creditTypeId: this.selectedAccount?.creditTypeId || 0,
      accountCreditEnabled : this.selectedAccount?.accountCreditEnabled,
      openingBalance: this.selectedAccount?.openingBalance,
      openingBalanceTxnId: this.selectedAccount?.openingBalanceTxnId,
      asofDateOpeningBalance: this.selectedAccount?.asofDateOpeningBalance
    };

    return response;
  }

  modifyCustumAttributes(data) {
    data.forEach((element) => {
      if (
        element['customAttribute'] &&
        element['customAttribute']['pickListValues']
      ) {
        element['customAttribute']['pickListValues'] = JSON.stringify(
          element['customAttribute']['pickListValues']
        );
      }
    });
    return data;
  }

  setAccountAddresses() {
    const addressArr = [];
    this.accountTempAddress?.map((addressObj) => {
      addressArr.push({
        id: addressObj.id || 0,
        createdSource: addressObj.createdSource || this.app.userIP,
        createdBy: addressObj.createdBy || this.app.user.userId,
        createdDate: addressObj.createdDate || new Date(),
        accountId: addressObj.accountId || 0,
        addressId: addressObj.address?.id || 0, // need to change
        address: {
          id: addressObj.address?.id || 0,
          attnContactId: addressObj.address?.attnContactId || null,
          streetAddress1: addressObj.address?.streetAddress1 || '',
          streetAddress2: addressObj.address?.streetAddress2 || '',
          createdSource: addressObj.address?.createdSource || this.app.userIP,
          createdBy: addressObj.address?.createdBy || this.app.user.userId,
          createdDate: addressObj.address?.createdDate || new Date(),
          name:
            addressObj.address.addressType &&
            addressObj.address.addressType.name
              ? addressObj.address.addressType.name
              : addressObj.address?.name,
          description: addressObj.address?.description || '',
          addressName: addressObj.address?.addressName || '',
          latitude: addressObj.address?.latitude || null,
          longitude: addressObj.address?.longitude || null,
          cityId: addressObj.address?.city?.id || null,
          stateId: addressObj.address?.state?.id || null,
          countryId: addressObj.address?.country?.id || null,
          zipCode: addressObj.address?.zipCode || '',
          addressTypeId:
            addressObj.address?.addressType?.id ||
            addressObj.address?.addressTypeId,
          addressClassId:
            addressObj.address?.addressClass?.id ||
            addressObj.address?.addressClassId,
          customAttributeValues:
            addressObj.address.customAttributeValues &&
            addressObj.address.customAttributeValues.length > 0
              ? addressObj.address.customAttributeValues
              : null,
          statusId:
            addressObj.address && addressObj.address.statusId
              ? addressObj.address.statusId
              : 2,
          updatedBy: addressObj.address?.updatedBy || null,
          updatedDate: addressObj.address?.updatedDate || null,
          updatedSource: addressObj.address?.updatedSource || null,
          isDefault: addressObj.address?.isDefault || false,
        },
        updatedBy: addressObj.updatedBy || null,
        updatedDate: addressObj.updatedDate || null,
        updatedSource: addressObj.updatedSource || null,
      });
    });
    return addressArr.length ? addressArr : null;
  }

  clearStoredData() {
    this.selectedParentAccount = null;
    this.storedContactDetails = [];
    this.storedAccountEmails = [];
    this.storedAccountPhones = [];
    this.storedAccountSocials = [];
    this.selectedcontactProfileImages = [];
  }

  getCustomAttributePayload() {
    const accountInfoCustomPayload =
      this.customAttributeService.setSectionCustomPayload(
        this.selectedAccount,
        this.accountInfoCustomFields,
        AccountModuleId
      );
    const accountDetailsCustomPayload =
      this.customAttributeService.setSectionCustomPayload(
        this.selectedAccount,
        this.accountDetailsCustomFields,
        AccountModuleId
      );

    /** Custom section */
    const customSectionPayload = this.customSectionFields?.map((row) => {
      if(row != null && row.length > 0){
        return this.customAttributeService.setSectionCustomPayload(this.selectedAccount, row, AccountModuleId);
      }
    });
    const filteredCustomSection = customSectionPayload?.filter(item => item != null && item != undefined);
    const flattenedCustomSection = filteredCustomSection?.reduce((v, current) => v.concat(current), []);
    /** End Custom section */

    return [...accountInfoCustomPayload, ...accountDetailsCustomPayload, ...flattenedCustomSection];
  }

  verifyAndSubmitAccount(data, type) {
    this.isSubmitted = true;

    setTimeout(() => {
      this.onEditAccount(data, type);
    }, 200);
  }

  onEditAccount(data, type) {
    if (!this.accountForm.valid) {
      const invalid = [];
      const controls = this.accountForm.controls;
      for (const name in controls) {
        if (controls[name].invalid) {
          invalid.push(name);
        }
      }

      this.accountForm.markAllAsTouched();
      this.accountForm.markAsDirty();

      setTimeout(() => {
        this.scrollToError();
      }, 200);

      return;
    }

    // Also check for email fields custom validations and custom attributes
    const invalidField = document.querySelector('.p-invalid');

    if (invalidField) {
        const classList = Array.from(invalidField.classList);
        const customFieldsError = classList.find(element => element.startsWith('custom-fields-error'));

        if (classList.includes('details-error')) {
            this.tabIndex = 1;
        } else if (customFieldsError) {
            const tabIndex = parseInt(customFieldsError.split('custom-fields-error-')?.[1]||'0');
            this.tabIndex = tabIndex;
        } else {
            this.tabIndex = 0;
        }

        setTimeout(() => {
            this.scrollTo(invalidField);
        }, 200);
        return;
    }

    data['parent'] = this.selectedParentAccount;

    let accountData = this.getPreparedData(
      this.app.copyObjectWithoutRefrence(data)
    );
    if(this.tags?.length > 0){
      accountData.tags = this.tags;
    }else{
      accountData.tags = [];
    }

    if (
      this.selectedcontactProfileImages &&
      accountData?.accountContacts &&
      accountData?.accountContacts[0].contact
    ) {
      accountData.accountContacts[0].contact['contactProfileImages'] = this.app.copyObjectWithoutRefrence(this.selectedcontactProfileImages);
    }

    if (accountData?.accountTypes?.length) {
      if (this.selectedAccount && this.selectedAccount.id) {
        accountData.accountTypes.forEach((eachType) => {
          eachType['accountId'] = this.selectedAccount.id;
        });
      }
    }

    if (accountData?.accountContacts[0]?.contact?.contactRoles.length > 0) {
      accountData.accountContacts[0].contact.contactRoles = this.getContactRolesFormatedData
        (
          accountData.accountContacts[0].contact.contactRoles, this.selectedAccount.accountContacts[0].contact.contactRoles, this.contactRoles
        );
    }

    accountData.accountAddresses = this.setAccountAddresses();
    this.appMainService.isShowSpinner('Action Performed');
    this.accountService
      .updateAccount(accountData)
      .then((data) => {
        this.onAccountEditSuccess(data.id, type);
        this.messageService.add({
          severity: 'success',
          summary: 'Success',
          detail: 'Account Updated Sucessfully...',
        });
      })
      .catch((err) => {
        const detail: string =
          typeof err.error.Message === 'string'
            ? err.error.Message
            : 'Error While Account Update...';
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail,
        });
      })
      .finally(() => {
        this.appMainService.isHideSpinner('Action Performed');
        this.isSubmitted = false;
      });
  }

  onAccountEditSuccess(id, type): void {
    // this.storeService.setAccountData(null);
    // this.clearStoredData();

    if (this.selectedView == 'split') {
      this.getAccountDetailsAfterEdit.emit(id);
      this.app.getAllObjects(false);
    }

    this.getAccountListAfterEdit.emit();

    if (type == 'save') {
      this.selectedcontactProfileImages = [];
      this.closeModal.emit();
    } else if (type == 'view') {
      this.displayView = true;
      this.accountEditView();
    }
  }

  onChangeOwnership({ value: { id = 0 } }) {
    this.accountForm.patchValue({ ownershipId: id });
  }

  contactEmailCheck(emailDetails: any, formModel: any) {
    const emailAddress = emailDetails.tempValue;
    setTimeout(() => {
      if (
        formModel?.invalid ||
        !emailAddress ||
        !this.displayEditViewDialog ||
        this.isSubmitted
      )
        return;

      this.contactService
        .contactEmailValidation(
          emailAddress,
          CONTACT_ASSOCIATION_ID.ACCOUNT,
          emailDetails?.contactId
        )
        .pipe(takeUntil(this.ngUnsubscribe))
        .subscribe({
          next: (response) => {
            if (!response) {
              this.confirmationService.confirm({
                message: `${emailAddress} email already used in a contact, do you want to use it again?`,
                header: 'Email Already Used',
                icon: 'pi pi-exclamation-triangle',
                rejectLabel: 'Clear',
                acceptLabel: 'Yes',
                accept: () => {},
                reject: (type) => {
                  if (type == ConfirmEventType.REJECT)
                    emailDetails.tempValue = '';
                },
              });
            }
          },
          error: (error) => {},
        });
    }, 300);
  }

  hasMaxLengthError(formControlName: string): boolean {
    return this.accountForm?.get(formControlName)?.hasError('maxlength');
  }

  hasMaxLengthErrorContact(formControlName: string, length: number): boolean {
    return (
      this.formControl?.contact?.get(formControlName)?.value?.length > length
    );
  }

  hasPatternError(formControlName: string): boolean {
    return this.accountForm?.get(formControlName)?.hasError('pattern');
  }

  onCustomUpload(event, field, type) {
    field.customeAttachement = field.customeAttachement
      ? field.customeAttachement
      : [];
    for (let file of event.files) {
      let errors = [];
      this.appMainService.isShowSpinner('upload');
      if (type == 'image') {
        errors = validateFiles(file, 2, this.allowedExtensions);
      }
      if (errors.length > 0) {
        for (let error of errors) {
          this.messageService.add({
            severity: 'error',
            summary: 'Error',
            detail: error.fileName + ': ' + error.error,
          });
        }
        this.appMainService.isHideSpinner('upload');
      } else {
        uploadFiles(file, ({ name, content, size, extension }) => {
          let attachment = {
            name: name,
            content: content,
            extension: extension,
            sizeInBytes: size,
          };
          field.customeAttachement.push(attachment);
          this.appMainService.isHideSpinner('upload');
        });
      }
    }
  }

  getNewContact(data) {
    const contactModel = this.getAccountContactsModel(data);
    return this.fb.group(contactModel);
  }

  getAccountContactsModel(data) {
    return (() => {
      return {
        id: [0],
        createdSource: [this.app.userIP],
        createdBy: [this.app.user.userId],
        createdDate: [new Date()],
        updatedBy: [null],
        updatedDate: [null],
        updatedSource: [null],
        accountId: [0],
        contactId: [0],
        contact: this.fb.group({
          id: [0],
          createdSource: [this.app.userIP],
          createdBy: [this.app.user.userId],
          organizationId: [this.app.user.organizationId],
          createdDate: [new Date()],
          salutation: [data?.salutation],
          emailAddress: [],
          contactType: [],
          contactAssociationTypeId: CONTACT_ASSOCIATION_ID.ACCOUNT,
          associationId: 0,
          associationName: [],
          firstName: [
            '',
            [Validators.maxLength(100), Validators.pattern('^[^:]*$')],
          ],
          middleName: [
            '',
            [Validators.maxLength(100), Validators.pattern('^[^:]*$')],
          ],
          lastName: [
            '',
            [Validators.maxLength(100), Validators.pattern('^[^:]*$')],
          ],
          title: [''],
          gender: [],
          department: [],
          dateOfBirth: [''],
          contactSpokenLanguages: [],
          selectedContactSpokenLanguages: [],
          startDate: [null],
          jobFunction: [''],
          contactRoleId: [null],
          contactJobFunctionIds: [null], // for contact roles
          relationshipStatus: [],
          maritalStatus: [],
          source: [],
          annualIncome: [],
          education: [],
          fieldOfStudy: [],
          reportsTo: [],
          seniority: [],
          assistant: [],
          assistantPhone: [],
          sourceId: [null],
          isPrimaryContact: [true],
          businessCardPhoto: [''],
          profileImage: [''],
          description: [''],
          isActive: [''],
          statusId: [1],
          updatedBy: [null],
          updatedDate: [null],
          updatedSource: [null],
          degree: [null],
          contactRoles: [],
          customAttributeValues: this.fb.array(this.newCustomAttributes([])),
        }),
      };
    })();
  }

  newCustomAttributes(account_info) {
    if (!account_info || account_info.length == 0) return [];
    let customAttibutesArray = [];
    account_info.forEach((element) => {
      if (element.isDelete) {
        customAttibutesArray.push(this.newCustomAttribute(element));
      }
    });
    return customAttibutesArray;
  }

  downloadFile(name, content, location?): void {
    this.fileService.downloadFile(name, content, location);
  }

  removeImg(index, field) {
    field.customeAttachment.splice(index, 1);
  }

  newCustomAttribute(control): FormGroup {
    return this.fb.group(this.createFormField(control));
  }

  getUserAccessByTerritory(): void {
    this.appMainService.isShowSpinner('getUserAccessByTerritory');
    this.accountServiceN
      .getUserAccess(this.selectedAccount?.id)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe({
        next: (response) => {
          this.userAccessByTerritoryList = response.filter(
            (x) => x.ownerType == 'Primary Owner'
          );
        },
        error: () => {
          this.appMainService.isHideSpinner('getUserAccessByTerritory');
        },
        complete: () => {
          this.appMainService.isHideSpinner('getUserAccessByTerritory');
        },
      });
  }

  //#region ***Dropdown List Loading***
  getDropdownValues(): void {
    this.loadSalutations();
    this.loadJobFunctions();
    this.loadAccountTypes();
    this.loadAccountSources();
    this.loadEmployeeCount();
    this.loadTimezones();
    this.loadCurrencies();
    this.loadRatings();
    this.loadAnnualRevenues();
    this.loadOwnerships();
    this.loadIndustries();
    this.loadCountries();
    this.loadLanguages();
    this.loadAddressTypes();
    this.loadAddressClasses();
    this.loadContactRoles();
    !this.accountTypes?.length &&
      this.accountDataService.dispatchGettingAllStores();
    !this.salutations?.length &&
      this.sharedDataService.dispatchGettingAllStores();
  }

  loadUsers(): void {
    this.activeUsers = this.app.usersList.filter((obj) => obj.statusId == 1);
  }

  loadSalutations(): void {
    this.sharedDataService
      .loadSalutations()
      .pipe(
        map((salutations) => {
          this.salutations = salutations;
        }),
        catchError(() => [])
      )
      .subscribe();
  }

  loadJobFunctions(): void {
    this.sharedDataService
      .loadJobFunctions()
      .pipe(
        map((jobFunctions) => {
          this.jobFunctions = jobFunctions;
        }),
        catchError(() => (this.jobFunctions = []))
      )
      .subscribe();
  }

  loadAccountTypes(): void {
    this.accountDataService
      .loadAccountTypes()
      .pipe(
        map((accountTypes) => {
          this.accountTypes = accountTypes;
        }),
        catchError(() => [])
      )
      .subscribe();
  }

  loadAccountSources(): void {
    this.sharedDataService
      .loadSources()
      .pipe(
        map((accountSources) => {
          this.accountSources = accountSources;
        }),
        catchError(() => [])
      )
      .subscribe();
  }

  loadEmployeeCount(): void {
    this.accountDataService
      .loadEmployeeCounts()
      .pipe(
        map((employeeCount) => {
          this.employeeCount = employeeCount;
        }),
        catchError(() => [])
      )
      .subscribe();
  }

  loadTimezones(): void {
    this.accountDataService
      .loadTimezones()
      .pipe(
        map((timezones) => {
          this.timezones = timezones || [];
        }),
        catchError(() => [])
      )
      .subscribe();
  }

  loadCurrencies(): void {
    this.importService.getOrgCurrency().subscribe(value=>{
      if(value){
        this.currencies = value;
        const activeCurrencies = this.currencies.filter(currency => currency?.statusId === 1);
          this.currencies = activeCurrencies.map((el) => {
            return {
              id: el.currencyId,
              name: el.code + ' - ' + el.country?.name,
            };
          });
      }
    });
  }

  loadRatings(): void {
    this.accountDataService
      .loadRatings()
      .pipe(
        map((ratings) => {
          if (ratings) {
            this.ratings = ratings;
          }
        }),
        catchError(() => [])
      )
      .subscribe();
  }

  loadAnnualRevenues(): void {
    this.accountDataService
      .loadAnnualRevenues()
      .pipe(
        map((revenues) => {
          this.revenues = revenues;
        }),
        catchError(() => [])
      )
      .subscribe();
  }

  loadOwnerships(): void {
    this.accountDataService
      .loadOwnerships()
      .pipe(
        map((ownerships) => {
          this.ownerships = ownerships;
        }),
        catchError(() => [])
      )
      .subscribe();
  }

  loadIndustries(): void {
    this.accountDataService
      .loadIndustries()
      .pipe(
        map((industries) => {
          this.industries = industries;
        }),
        catchError(() => [])
      )
      .subscribe();
  }

  loadCountries(): void {
    this.sharedDataService
      .loadCountries()
      .pipe(
        map((countries) => {
          this.countries = countries || [];
        }),
        catchError(() => [])
      )
      .subscribe();
  }

  loadLanguages(): void {
    this.sharedDataService
      .loadLanguages()
      .pipe(
        map((languages) => {
          this.languages = languages || [];
        }),
        catchError(() => [])
      )
      .subscribe();
  }

  loadAddressTypes(): void {
    this.sharedDataService
      .loadAddressTypes()
      .pipe(
        map((addressTypes) => {
          this.addressTypes = addressTypes?.filter((el) => el.isActive) || [];
        }),
        catchError(() => [])
      )
      .subscribe();
  }

  loadAddressClasses(): void {
    this.sharedDataService
      .loadAddressClasses()
      .pipe(
        map((addressClasses) => {
          this.addressClasses =
            addressClasses?.filter((el) => el.isActive) || [];
        }),
        catchError(() => [])
      )
      .subscribe();
  }

  getAllStages() {
    this.accountServiceN
      .getStageList(this.objectId, this.selectedChannelId)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((stages) => {
        let resValue = [];
        if (stages) {
          resValue = stages
            .filter((el) => el.id && el.id !== -1)
            .map((x) => ({ id: x.id, name: x.name }));
        }

        this.stages = resValue;
        if (this.displayEditViewDialog && this.selectedAccount && this.accountForm) {
          this.setBusinessClassification();
        }
      });
  }

  //#endregion

  onCancelAddEdit() {
    this.accountExistMsg = '';
    this.closeModal.emit();
    //this.displayEditViewDialog = false;
  }

  //tags
  removeTag(i) {
    this.tags.splice(i, 1);
  }

  addTag() {
    this.displayAddTag = true;
    if (this.tags?.length > 0) {
      this.tags = JSON.parse(JSON.stringify(this.removeDuplicates(this.tags)));
      this.selectedValues = this.tags;
    }
  }

  removeDuplicates(arr: Tag[]): Tag[] {
    const uniqueSet = new Set();

    const uniqueArray = arr.filter((obj) => {
      const objString = JSON.stringify(obj);
      if (!uniqueSet.has(objString)) {
        uniqueSet.add(objString);
        return true;
      }
      return false;
    });
    return uniqueArray;
  }

  loadTags() {
    this.accountServiceN
      .getAllTags()
      .pipe(
        tap((tags) => {
          const filteredTags = tags.filter((data) => data?.statusId == 1);
          this.tagList = JSON.parse(JSON.stringify(filteredTags));
        }),
        catchError(() => of([])),
        takeUntil(this.ngUnsubscribe)
      )
      .subscribe();
  }

  createTag(tag: Tag) {
    this.accountServiceN
      .addTags(tag)
      .pipe(
        tap((tag: Tag) => {
          if (tag !== null) {
            this.loadTags();
            this.messageService.add({
              severity: 'success',
              summary: 'Success',
              detail: 'Added Successfully...',
            });
          } else {
            this.messageService.add({
              severity: 'error',
              summary: 'Error',
              detail: 'Duplicate tag names are not allowed.',
            });
          }
          this.displayCreateTag = false;
        }),
        catchError(() => of(null)),
        takeUntil(this.ngUnsubscribe)
      )
      .subscribe();
  }

  assignSelectedTags(tags: Tag[]) {
    if (tags.length > 0) {
      this.tags = JSON.parse(JSON.stringify(this.removeDuplicates(tags)));
    }
    this.displayAddTag = false;
  }

  setStageOwnerAccordingToStage(value) {
    if (value) {
      this.selectedOwnerStage = this.stages?.find(data => data?.id == value?.id);
      if(this.selectedOwnerStageDefault == value?.id){
        this.stageCommentEnable = false;
        this.accountForm.patchValue({ comment: null });
      }else{
        this.stageCommentEnable =  true;
      }
    }
  }

  setDefaultStage() {
    this.selectedOwnerStageDefault = this.selectedAccount?.businessClassificationId;
  }

  getCountryCode(data?) {
    this.accountUserService.countryCode().pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(
        {
          next: (response) => {
            this.countryData = response;
          },
          error: (error) => {
            this.appMainService.isHideSpinner('authenSetUp');
            this.messageService.add({
              severity: 'error',
              summary: 'Error',
              detail: error?.error?.message ? error?.error?.message : 'please try again...'
            });

          },
          complete: () => { },
        });
  }

  onCountrySelect(event: any, phoneType: any, isNumber: boolean = false) {
    const selectedCountry = this.countryData.find(item => item.CountryName === event.value);
    if(selectedCountry && phoneType){
      phoneType.phone.code = selectedCountry.PhoneCode;
    }
  }

  async getPhoneNumberTemplate(){
    this.phoneNumberFormat = await this.phoneNumberFormatService.getPhoneNumberFormat();
  }

  loadContactRoles(): void {
    this.appMainService.isShowSpinner('contactRoles');
    this.configurationService.getNewAllContactRoles().subscribe({
      next: (resp: any[]) => {
        this.contactRoles  = resp?.length ? resp : [];
        this.appMainService.isHideSpinner('contactRoles');
      },
      error: (err) => {
        this.appMainService.isHideSpinner('contactRoles');
      }
    });
  }

  getContactRolesId(contactRole: any) {
    if (contactRole && contactRole.length) {
      const contactRoleId = contactRole.map((role) => role.roleId);
      return contactRoleId;
    }
    return null;
  }

  getContactRolesFormatedData(selectedContactRolesIds, getByIdContactRoles = [], dropdownContactRoles = []) {
    const formatedContactRoles = [];
    const notAvailabeInGetByIdContactRoles = [];
    selectedContactRolesIds?.forEach((type) => {
      const existingRole = getByIdContactRoles?.find((data) => data.roleId === type);

      if (existingRole) {
        // If found in getByIdContactRoles, use that object
        formatedContactRoles.push({
          ...existingRole
        });
      } else {
        // If not found, collect for processing with dropdownContactRoles
        notAvailabeInGetByIdContactRoles.push(type);
      }
    });

    // Process the IDs not found in getByIdContactRoles
    notAvailabeInGetByIdContactRoles.forEach((type) => {
      const findObject = dropdownContactRoles?.find((data) => data.id === type);

      if (findObject) {
        formatedContactRoles.push({
          contactId: findObject?.contactId || 0,
          roleId: findObject?.id,
          statusId: findObject?.statusId || 1,
          roleName: findObject.name,
          id: 0,
          createdSource: findObject?.createdSource || this.app.userIP,
          createdBy: findObject?.createdBy || this.app.user.userId,
          createdDate: findObject?.createdDate || new Date()
        });
      }
    });

    getByIdContactRoles?.forEach(existingRole => {
      const isStillSelected = selectedContactRolesIds.includes(existingRole.roleId);
      
      if (!isStillSelected) {
        // This role was previously assigned but now unselected
        formatedContactRoles.push({
          ...existingRole,
          statusId: 3,
          updatedBy: this.app.user.userId,
          updatedDate: new Date(),
          updatedSource: this.app.userIP
        });
      }
    })
    return formatedContactRoles;
  }
}
